require('./style.less');

var Marionette = require('marionette'),
    Mousetrap = require('mousetrap'),

    PageView = require('./page/view'),
    FCFieldView = require('./page/fcFields/view'),
    DocPropView = require('./page/docProps/view'),
    DocNotesView = require('./page/docNotes/view'),
    RmaPropsView = require('./page/rmaProps/view');

require('extendJQuery');
require('backbone.mousetrap');

/* Note: also contains the jQ $hits -- all interactions with go through here */
module.exports = Marionette.CollectionView.extend({
    className: 'ftPages',
    getChildView: function(pageModel) {
        switch ( pageModel.get('pgViewType') ) {
            case 'FC_FIELDS':
                return FCFieldView;
            case 'DOC_PROPS':
                return DocPropView;
            case 'DOC_NOTES':
                return DocNotesView;
            case 'RMA_PROPS':
            case 'SECURITY_PROPS':
                return RmaPropsView;
            default: 
                return PageView;
        }

    },
    childViewOptions: function() {
        //now only passing what's needed, could pass lCh, state ...
        return {
            pageLabelAction: this.options.state.get('pageLabelAction')
        };
    },
    initialize: function(options) {
        _.extend(this, _.pick(options, 'lCh', 'collection'));
        this.lCh.comply({
            calcPageBottoms: this.calcPageBottoms
        }, this);
    },
    onRender: function() {
        var state = this.options.state;
        state.get('grepMode') && this.$el.addClass('grepMode');
        state.get('localGrepMode') && this.$el.addClass('localGrepMode');
        state.get('wrapText') && this.$el.addClass('wrapText');
    },
    onShow: function() {
        this.children.length > 0 && this.children.last().$el.addClass('lastPage');
    },
    // TODO: rename
    calcPageBottoms: function() {
        var tHt = 0;
        this.collection.each(function(p, i) {
            p.set('top', tHt);
            tHt += this.children.findByIndex(i).$el.outerHeight();
            p.set('bottom', tHt);
        }, this);
    },
    onWrapTextToggle: function() {
        this.$el.toggleClass('wrapText'); //allow overflow/not
        this._postSizeChangeActions();
    },
    _postSizeChangeActions: function() {
        //TODO: got back to relative scroll position
        this.calcPageBottoms();
    },
    onBeforeDestroy: function() {
        this.lCh.stopComplying('calcPageBottoms');
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/fulltext/layout/content/pages/pagesView.js
 ** module id = 539
 ** module chunks = 0
 **/